export default "__VITE_ASSET__7e9b7c95__"